import fp from 'lodash/fp'

export const toOptions = fp.flow(
  fp.entries,
  fp.map(([key, value]) => ({ id: fp.toUpper(key), name: value }))
)
